import React from 'react';
import { Box, Dialog, Typography } from '@mui/material';
import { ReactComponent as HighlightOffOutlinedIcon } from '../../assets/imgs/close.svg';
import InputWithLabel from '../common/InputWithLabel';
import { black, mercury, shark, wildSand } from '../../constants/colors';
import DynamicButton from '../new/Button';

export const CompanyDetailsModal = ({
  open,
  handleClose,
  updateCompany,
  company,
  handleChange,
}) => {
  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: styles.paper }}>
      <Typography variant="h5" sx={styles.heading}>
        Update Company Details
        <HighlightOffOutlinedIcon
          style={styles.closeIcon}
          onClick={handleClose}
        />
      </Typography>

      <InputWithLabel
        label="Company name"
        name="company_name"
        value={company?.name}
        placeholder="Company name"
        handleChange={(e) => handleChange(e, 'name')}
      />

      <Box sx={styles.btns}>
        <DynamicButton type="outlined" sx={styles.cancel} onClick={handleClose}>
          Cancel
        </DynamicButton>
        <DynamicButton
          type="contained"
          sx={styles.template}
          onClick={updateCompany}
        >
          Update
        </DynamicButton>
      </Box>
    </Dialog>
  );
};

const styles = {
  paper: {
    borderRadius: '8px',
    padding: '32px',
    width: '458px',
  },
  heading: {
    color: black,
    fontFamily: 'SoehneBold',
    fontSize: '20px',
    lineHeight: '32px',
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeIcon: {
    color: shark,
    fontSize: '30px',
    borderRadius: '50%',
    padding: '5px',
    cursor: 'pointer',
  },
  btns: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '24px',
    marginTop: '25px',
  },
  cancel: {
    color: black,
    width: '81px',
    height: '40px',
    background: mercury,
    borderRadius: '100px',
    boxShadow: 'none',
    border: `1px solid ${mercury}`,
    fontSize: '16px',
    '&:hover': { background: mercury },
  },
  template: {
    color: 'white',
    width: '138px',
    height: '40px',
    borderRadius: '100px',
    boxShadow: 'none',
    fontSize: '16px',
  },
};
